import {
  AlertTitle,
  OptionLabel,
} from "Components/TextContext/commonComponentEnums";

import { WrapMdMarginBottom } from "App/global-style";
import { ContactUsAlert } from "Components/Form/Alert";
import { RadioButtonTrueFalse } from "Components/Form/RadioButton";
import { useTexts } from "Components/TextContext";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { formBooleanToBoolean } from "Utils/formUtils";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";

interface Historical {
  historicalValue?: BooleanFormType;
}

interface Props<T extends Historical = Historical> {
  formProps: FormikProps<T>;
  label: string;
}

export const HistoricalValue = ({
  formProps,
  label,
}: Props): React.ReactElement => {
  const { getText } = useTexts();

  return (
    <>
      <RadioButtonTrueFalse
        direction="vertical"
        name="historicalValue"
        id="historicalValue"
        label={label}
        error={getError("historicalValue", formProps)}
        options={[
          {
            id: "historicalValue-yes",
            label: getText(OptionLabel.BOOLEAN_YES),
            value: true,
          },
          {
            id: "historicalValue-no",
            label: getText(OptionLabel.BOOLEAN_NO),
            value: false,
          },
        ]}
      />
      {formBooleanToBoolean(formProps.values.historicalValue) && (
        <WrapMdMarginBottom>
          <ContactUsAlert
            description={getText("houseform.validation.historicalvalue")}
            title={getText(AlertTitle.CALL_US)}
            alertId="historicalValue"
          />
        </WrapMdMarginBottom>
      )}
    </>
  );
};
